export default {
  // Left Menu Admin
  "configLeftMenuAdmin.add": "添加",
  "configLeftMenuAdmin.details": "详情",
  "configLeftMenuAdmin.edit": "编辑",
  "configLeftMenuAdmin.delete": "删除",
  "configLeftMenuAdmin.delete.confirm.title": "删除配置",
  "configLeftMenuAdmin.delete.confirm.content": "确定要删除这个配置吗？",
  "configLeftMenuAdmin.delete.confirm.okText": "确定",
  "configLeftMenuAdmin.delete.confirm.cancelText": "取消",
  "configLeftMenuAdmin.modal.title": "左侧菜单配置",
  "configLeftMenuAdmin.thead.createdAt": "创建时间",
  "configLeftMenuAdmin.thead.updatedAt": "更新时间",
  "configLeftMenuAdmin.thead.action": "操作",

  // Left Menu fields
  "configLeftMenuAdmin.thead.id": "ID",
  "configLeftMenuAdmin.thead.title": "标题",
  "configLeftMenuAdmin.thead.url": "URL",
  "configLeftMenuAdmin.thead.activeKey": "激活键",
  "configLeftMenuAdmin.thead.parentId": "父级ID",
  "configLeftMenuAdmin.thead.type": "类型",
  "configLeftMenuAdmin.thead.ItemId": "项目ID",
  "configLeftMenuAdmin.thead.params": "参数",
  "configLeftMenuAdmin.thead.iconUrl": "图标URL",
  "configLeftMenuAdmin.thead.sort": "排序",
  "configLeftMenuAdmin.thead.hideMenu": "隐藏菜单",
  "configLeftMenuAdmin.thead.seo": "SEO",
  "configLeftMenuAdmin.thead.loginToDirect": "登录后跳转",
  "configLeftMenuAdmin.thead.siteKey": "站点键",
  "configLeftMenuAdmin.thead.bindSite": "绑定站点",
  "configLeftMenuAdmin.thead.setDefaultData": "设置默认数据",
  "configLeftMenuAdmin.thead.deviceType": "设备类型",
  "configLeftMenuAdmin.thead.documentId": "文档ID",
  "configLeftMenuAdmin.thead.createdBy": "创建者",
  "configLeftMenuAdmin.thead.updatedBy": "更新者"
};